if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  });
  // --- Fix: permitir que la X cierre el modal de producto ---
document.addEventListener('click', function (e) {
  // Botones/enlaces típicos de cierre (amplía si tu tema usa otro)
  const closeBtn = e.target.closest(
    '.modal_close, .js-modal-close, .product-modalclose, .product-media-modal_close, [data-close-modal], [aria-label="Close"]'
  );
  if (!closeBtn) return;

  e.preventDefault();

  // Contenedor del modal (dialog o div)
  const modal = closeBtn.closest('dialog, .product-modal, .product-media-modal, .modal, .media-modal');

  // Si es <dialog>, usa close()
  if (modal && typeof modal.close === 'function') {
    modal.close();
  }

  // Para modales que usan clases/atributos
  if (modal && modal.classList) {
    modal.classList.remove('open', 'active', 'is-active');
    modal.setAttribute('aria-hidden', 'true');
  }
});
}
